<template>
  <div class="success-page">
    <div class="success-card">
      <div class="success-icon">
        <svg xmlns="http://www.w3.org/2000/svg" width="80" height="80" viewBox="0 0 24 24" fill="none">
          <circle cx="12" cy="12" r="10" stroke="#1a73e8" stroke-width="2"></circle>
          <path d="M8 12L10.5 14.5L16 9" stroke="#1a73e8" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
        </svg>
      </div>

      <h1>成功簽署貸款合約！</h1>

      <div class="status-message">
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <circle cx="12" cy="12" r="10"></circle>
          <line x1="12" y1="8" x2="12" y2="12"></line>
          <line x1="12" y1="16" x2="12.01" y2="16"></line>
        </svg>
        恭喜你！你的貸款申請即將完成。
      </div>

      <div v-if="agreementInfo" class="agreement-info">
        <p>貸款合約編號：<strong>{{ agreementInfo.signedLoanRef }}</strong></p>
        <p>簽署時間：<strong>{{ agreementInfo.timestamp }}</strong></p>
      </div>

      <div class="next-steps">
        <h2>請耐心等侯</h2>
        <ol>
          <li>工作人員將審核你已簽署的貸款合約</li>
          <li>貸款資金將在確認後 <strong>{{ loanProcessTime }}</strong> 內發放至你的指定帳戶</li>
        </ol>
      </div>

      <div class="action-buttons">
        <button class="close-btn" @click="closeWindow">
          完成
        </button>
      </div>

      <div class="contact-info">
        <p>如有任何問題，請聯繫客戶服務：</p>
        <p class="service-phone">客服專線：{{ companyPhone }}</p>
        <p class="service-hours">{{ serviceHours }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, onMounted } from 'vue';
import { useRoute, useRouter } from 'vue-router';

export default {
  setup() {
    const route = useRoute();
    const router = useRouter();

    const companyPhone = process.env.VUE_APP_COMPANY_PHONE;
    const serviceHours = process.env.VUE_APP_COMPANY_SERVICE_HOURS || '週一至週五 9:00-18:00';
    const loanProcessTime = process.env.VUE_APP_LOAN_PROCESS_TIME || '1-2個工作日';

    // 協議信息
    const agreementInfo = ref(null);

    // 驗證頁面訪問權限
    onMounted(() => {
      // 檢查URL中是否有協議ID
      const agreementId = route.query.id;

      // 從localStorage獲取已簽署的協議ID和相關資訊
      const signedAgreementId = localStorage.getItem('signedAgreementId');
      const signedLoanRef = localStorage.getItem('signedLoanRef');
      const signatureTimestamp = localStorage.getItem('signatureTimestamp');

      // 如果URL中的ID與已簽署的ID不匹配，或者沒有已簽署的ID，則重定向到錯誤頁面
      if (!agreementId || agreementId !== signedAgreementId) {
        console.log('無效的成功頁面訪問');
        router.push('/error');
        return;
      }

      // 設置協議信息
      agreementInfo.value = {
        id: agreementId,
        signedLoanRef: signedLoanRef,
        timestamp: signatureTimestamp
      };

      // 檢查是否直接訪問（而不是從協議頁面跳轉而來）
      const referrer = document.referrer;
      if (!referrer.includes('/agreement/')) {
        console.log('直接訪問成功頁面');
        // 可以選擇是否重定向到錯誤頁面
        // router.push('/error');
      }
    });

    const closeWindow = () => {
      // 清除會話存儲的協議數據
      localStorage.removeItem('signedAgreementId');
      localStorage.removeItem('signatureTimestamp');

      // 如果在 iframe 中，向父窗口發送消息
      if (window !== window.top) {
        window.parent.postMessage('agreement_completed', '*');
      } else {
        // 否則轉回主頁或指定頁面
        window.location.href = process.env.VUE_APP_COMPLETION_REDIRECT_URL || '/';
      }
    };

    return {
      companyPhone,
      serviceHours,
      loanProcessTime,
      agreementInfo,
      closeWindow
    };
  }
};
</script>

<style scoped>
.success-page {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #f8f9fa;
  font-family: 'Noto Sans TC', sans-serif;
  padding: 16px;
  min-height: 80vh;
}

.success-card {
  max-width: 550px;
  width: 100%;
  background: white;
  padding: 32px;
  border-radius: 12px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  text-align: center;
}

.success-icon {
  color: #1a73e8;
  margin: 0 auto 24px;
  display: flex;
  justify-content: center;
  animation: scaleIn 0.5s ease-out;
}

@keyframes scaleIn {
  0% {
    transform: scale(0.5);
    opacity: 0;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}

h1 {
  color: #202124;
  margin-bottom: 24px;
  font-size: 28px;
  font-weight: 600;
}

h2 {
  margin-top: 0;
  font-size: 18px;
  color: #202124;
  margin-bottom: 16px;
  font-weight: 500;
  text-align: left;
}

.status-message {
  background-color: #e8f0fe;
  border-radius: 8px;
  padding: 16px;
  color: #174ea6;
  margin-bottom: 24px;
  display: flex;
  align-items: flex-start;
  gap: 10px;
  text-align: left;
}

.status-message p {
  margin: 0;
  line-height: 1.5;
  font-size: 15px;
}

.agreement-info {
  background-color: #f8f9fa;
  border-radius: 8px;
  padding: 16px;
  margin-bottom: 24px;
  text-align: left;
  border: 1px solid #dadce0;
}

.agreement-info p {
  margin: 0 0 8px 0;
  color: #5f6368;
  font-size: 14px;
}

.agreement-info p:last-child {
  margin-bottom: 0;
}

.agreement-info strong {
  color: #202124;
  font-weight: 500;
}

.next-steps {
  text-align: left;
  background: #f8f9fa;
  padding: 20px;
  border-radius: 8px;
  margin-bottom: 24px;
  border: 1px solid #dadce0;
}

.next-steps ol {
  margin: 0;
  padding-left: 20px;
  margin-bottom: 16px;
}

.next-steps li {
  margin-bottom: 8px;
  line-height: 1.5;
  color: #202124;
  font-size: 15px;
}

.next-steps li:last-child {
  margin-bottom: 0;
}

.notice {
  margin-top: 16px;
  padding: 12px;
  background-color: #fff8e1;
  border-radius: 6px;
  display: flex;
  align-items: flex-start;
  gap: 8px;
}

.notice svg {
  color: #f9a825;
  flex-shrink: 0;
  margin-top: 2px;
}

.notice p {
  margin: 0;
  color: #5d4037;
  font-size: 14px;
  line-height: 1.5;
}

.action-buttons {
  display: flex;
  justify-content: center;
  margin-top: 16px;
  margin-bottom: 24px;
}

.close-btn {
  padding: 12px 40px;
  border-radius: 8px;
  font-weight: 500;
  cursor: pointer;
  font-size: 16px;
  transition: all 0.2s ease;
  background-color: #1a73e8;
  color: white;
  border: none;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
  min-width: 180px;
}

.close-btn:hover {
  background-color: #1765cc;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
}

.contact-info {
  margin-top: 24px;
  padding-top: 20px;
  border-top: 1px solid #e8eaed;
  font-size: 14px;
  color: #5f6368;
}

.service-phone {
  margin: 8px 0;
  font-weight: 500;
  color: #202124;
}

.service-hours {
  font-size: 13px;
}

@media (max-width: 600px) {
  .success-card {
    padding: 24px 16px;
  }

  .close-btn {
    width: 100%;
  }

  h1 {
    font-size: 24px;
  }
}
</style>